export default function() {
  return [
    { name: 'facebook/react' },
    { name: 'vuejs/vue' },
    { name: 'angular/angular' },
  ]
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_repositories.js